import { BridgePanel } from '@/features/bridge/components/BridgePanel'
import { BridgeViewProps } from '../logic/types'

export function BridgeView(props: BridgeViewProps) {
  const { bridge, withHeading } = props

  return <BridgePanel bridge={bridge} withHeading={withHeading} />
}
